import ContactForm from "@/components/ContactForm";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Contact() {
  return (
    <div>
      <section className="pt-16 md:pt-24 pb-16 md:pb-20 border-b border-[#27272a] relative overflow-hidden">
        <div className="absolute inset-0 radial-fade" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-3xl">
            <div className="eyebrow mb-6">
              <span className="gold-line" />
              Contact
            </div>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05]">
              Build my <span className="text-[#C8A24B]">growth plan.</span>
            </h1>
            <p className="mt-8 text-lg text-[#a1a1aa] leading-relaxed max-w-2xl">
              Tell us where you are today. We will look at your current
              presence, understand your goals, and recommend the right next
              step. You do not need to know exactly what you need yet.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-[1.4fr_1fr] gap-14 items-start">
          <div className="order-2 lg:order-1">
            <ContactForm />
          </div>
          <aside className="order-1 lg:order-2 space-y-8">
            <div className="border border-[#27272a] bg-[#0e0e0e] p-8 rounded-sm relative">
              <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#C8A24B]" />
              <div className="text-[10px] tracking-[0.28em] uppercase text-[#71717a] mb-4">
                What Happens Next
              </div>
              <ol className="space-y-4">
                {[
                  {
                    n: "01",
                    t: "We review your request",
                    d: "We look at your stage, goals, and services of interest.",
                  },
                  {
                    n: "02",
                    t: "Short fit conversation",
                    d: "A brief call to make sure we are the right match.",
                  },
                  {
                    n: "03",
                    t: "Growth plan recommendation",
                    d: "We suggest what to build first and what can wait.",
                  },
                ].map((s) => (
                  <li key={s.n} className="flex gap-4">
                    <div className="font-heading text-xs text-[#C8A24B] tracking-widest pt-1">
                      {s.n}
                    </div>
                    <div>
                      <div className="text-white font-medium mb-1">{s.t}</div>
                      <div className="text-sm text-[#a1a1aa] leading-relaxed">
                        {s.d}
                      </div>
                    </div>
                  </li>
                ))}
              </ol>
            </div>

            <div className="border border-[#27272a] bg-[#0e0e0e] p-8 rounded-sm">
              <div className="text-[10px] tracking-[0.28em] uppercase text-[#71717a] mb-4">
                Reach Us
              </div>
              <ul className="space-y-4 text-sm">
                <li className="flex items-start gap-3">
                  <Mail size={14} className="text-[#C8A24B] mt-0.5" />
                  <a
                    href="mailto:contact@kostaja.ca"
                    className="text-[#d4d4d8] hover:text-[#C8A24B]"
                  >
                    contact@kostaja.ca
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <MapPin size={14} className="text-[#C8A24B] mt-0.5" />
                  <div className="text-[#d4d4d8]">
                    Ontario, Canada
                    <div className="text-xs text-[#71717a] mt-1">
                      Serving Canada, United States, Australia, and England.
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div className="text-xs text-[#71717a] leading-relaxed">
              Agent Marketing is a branded division of Kostaja Ltd.
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
}
